module.exports = __webpack_public_path__ + "static/media/day14_parallax.de8faa22.gif";